import router from '@/router'

export default {
  name: 'CabinetPage',
  components: {
  },
  data () {
    return {
      cabinetImageURL: 'static/Cabinet/cabinet-1.jpg',
      cabinetImages: [
        {
          src: 'static/Cabinet/cabinet-1.jpg',
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/cabinet/cabinet.component.js